/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import AppInput from "../../forms/AppInput";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { createTutorNote } from "../../../api/endpoints/tutors/notes";
import { useNavigate } from "react-router-dom";

export default function AddNoteSide({
  open,
  setOpen,
  sessionId,
  sessionNumber,
  getSession,
}: any) {
  const LocalBasePath = "page.addNote";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const navigate = useNavigate();
  const addUserNote = async (title: string) => {
    const addNewNote = await createTutorNote({
      session_id: sessionId,
      title: title,
    });
    if (addNewNote.isSuccess) {
      setOpen(false);
      getSession(sessionId);
      // navigate("tutor/dashboard/sessions");
    }
  };

  useEffect(() => {
    reset();
  }, [open]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const onSubmit = (data: any) => {
    addUserNote(data.title);
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 overflow-hidden"
        onClose={setOpen}
      >
        <div className="absolute inset-0 overflow-hidden" data-cy="noteModal">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className="pointer-events-auto relative w-screen max-w-md">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-500"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-500"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
                    <button
                      type="button"
                      className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      onClick={() => setOpen(false)}
                    >
                      <span className="sr-only">Close panel</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </Transition.Child>
                <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                  <div className="px-4 sm:px-6">
                    <Dialog.Title className="text-lg font-medium text-gray-900">
                      {" "}
                      {t("addNoteFor")} #{sessionNumber}{" "}
                    </Dialog.Title>
                  </div>
                  <div className="relative mt-6 flex-1 px-4 sm:px-6">
                    {/* Replace with your content */}
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="mt-1">
                        <AppInput
                          hideLabel={true}
                          label={t("title")}
                          register={register}
                          error={errors.title}
                          scehema={{
                            required: true,
                          }}
                          placeholder={t("title")}
                          type="text"
                          name="title"
                          id="title"
                          className="shadow-sm focus:ring-brandblue-500 focus:border-brandblue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        />
                      </div>
                      <button data-cy="saveNote" className="my-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500 disabled:bg-gray-400">
                        {t("save")}
                      </button>
                    </form>
                    {/* /End replace */}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
